import { useRef, useState } from 'react'
import Carousel from 'react-multi-carousel'

import Button from 'common/components/button'
import { ChevronLeft, ChevronRight } from 'common/icons'
import useGetGraphsQuery from 'features/personalization/api/queries/useGetGraphs'

import GridView from './GirdView'
import Graph from './Graph'

import 'react-multi-carousel/lib/styles.css'

const Graphs = () => {
  const carouselRef = useRef<Carousel>(null)
  const responsive = {
    xs: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
    sm: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    md: {
      breakpoint: { max: 1600, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    xl: {
      breakpoint: { max: 9000, min: 1600 },
      items: 4,
    },
  }

  const [isPreviousButtonDisabled, setIsPreviousButtonDisabled] =
    useState(false)
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false)
  const [isShowAll, setIsShowAll] = useState(false)

  const graphsQuery = useGetGraphsQuery()

  if (graphsQuery.isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className="w-full px-6 pb-8">
      <div className="">
        <div className="mb-6 flex justify-between">
          <div className="text-xl font-medium text-gray-800 ">Metrics</div>
          <div className="flex items-center gap-4">
            <Button
              variant="link"
              onClick={() => {
                setIsShowAll(!isShowAll)
                setIsPreviousButtonDisabled(!isShowAll)
                setIsNextButtonDisabled(!isShowAll)
              }}
            >
              {isShowAll ? 'Show less' : 'Show all'}
            </Button>
            <div className="flex text-coolGray-400 gap-4">
              <Button
                variant="icon"
                prefixIcon={<ChevronLeft />}
                onClick={() => {
                  carouselRef.current?.previous(1)
                }}
                disabled={isPreviousButtonDisabled}
              />
              <Button
                variant="icon"
                prefixIcon={<ChevronRight />}
                onClick={() => {
                  carouselRef.current?.next(1)
                }}
                disabled={isNextButtonDisabled}
              />
            </div>
          </div>
        </div>
        {isShowAll ? (
          <GridView>
            {graphsQuery.data?.map(({ displayName: label, value }) => (
              <div key={label} className="">
                <Graph label={label} value={value} />
              </div>
            ))}
          </GridView>
        ) : (
          <Carousel
            ref={carouselRef}
            infinite
            showDots={false}
            arrows={false}
            responsive={responsive}
            partialVisbile={true}
            keyBoardControl={true}
            containerClass="carousel-container"
            removeArrowOnDeviceType={['tablet', 'mobile']}
            itemClass="pr-6 last:pr-0"
            className="max-full w-full "
          >
            {graphsQuery.data?.map(({ displayName: label, value }) => (
              <Graph label={label} key={label} value={value} />
            ))}
          </Carousel>
        )}
      </div>
    </div>
  )
}

export default Graphs
